<template>
  <div>
    <pageTable/>
  </div>
</template>

<script>
import PageTable from './components/travle-table';
export default {
  name: 'personal-myTravel',
  components: {
    PageTable,
  },
}
</script>